import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity} from 'react-native';
export default class HMVideo extends Component {

    render() {
        const {path,item,style, text, icon, navigateParams, typeIcon} = this.props;
        return (
            <video width="100%" height="100%" controls>
                <source src={path ? path : (item.item && item.item.file ? item.item.file : (item.file?item.file:item))} type="video/mp4"/>

            </video>


        );
    }


}
